import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const feedbackFormKeys = new QueryKeyFactory('feedbackForm')
